module.exports = __webpack_public_path__ + "static/navblue-logo-8b76505ec5a2fcc66906ad995403bb75.png";